import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';

function ServicesSlider() {
    const settings = {
        dots: true,
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      };
  return (
    <div>
    <section className="section-padding thm-bg-light">
        <div className="container">
            <Slider {...settings} className="row service_slider">
                <div className="col-lg-12 slide_item">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-machine-learning icon"></i>
                        <h5 className="title">Machine Learning</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
               
                <div className="col-lg-12 slide_item">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-vision icon"></i>
                        <h5 className="title">Manage Analytics</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
                
                <div className="col-lg-12 slide_item">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-chatbot icon"></i>
                        <h5 className="title">Industrial Robot </h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
                
                <div className="col-lg-12 slide_item">
                    <Link to="/service-details" className="service_box">
                        <i className="flaticon-circuit-1 icon"></i>
                        <h5 className="title">Data Analsis</h5>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>
                    </Link>
                </div>
            </Slider>
        </div>
    </section>
    </div>
  )
}

export default ServicesSlider